import VueRouter from 'vue-router'
import Vue from 'global-vue'
import moment from 'moment'

import di from 'di';

import VueResource from 'vue-resource'

import { Validator } from 'vee-validate';

import * as VueGoogleMaps from 'vue2-google-maps'

export default class {

    run(){

        const config = di.get('config');

        Validator.installDateTimeValidators(moment);

        // Custom messages
        Validator.updateDictionary({
            nl: {
                custom: {
                    resolveActionFrequence: {
                        'in': 'De meet-/zendfrequentie moet zijn gecontroleerd om de actie af te sluiten'
                    }
                }
            }
        });

        /* ROUTER */
        Vue.use(VueRouter);

        /* RESOURCE */
        Vue.use(VueResource);
        Vue.http.options.root = config.apiUrl;

        /* MAPS */
        Vue.use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyAN5xbYn_0FUg6m3OhLKXMLrO3hKypnLbQ',
                libraries: 'places'
            }
        });
    }
}
